import { useContext } from "react";
import { UserPermissionContext, } from "../providers/user-permission";
var usePermissions = function () {
    return useContext(UserPermissionContext);
};
export default usePermissions;
